<div class="d-flex justify-content-center align-items-center py-2">
  <button class="btn-reset px-2" (click)="copy()" ngbTooltip="Copy">
    <ng-container *ngIf="!copiedStatus; else checkIcon">
      <i class="bi bi-copy"></i>
    </ng-container>
    <ng-template #checkIcon>
      <i class="bi bi-check2"></i>
    </ng-template>
  </button>

  <ng-container *ngIf="showFeedbackButtons">
    <button
      class="btn-reset px-2"
      (click)="onThumbClick('thumbs_up')"
      ngbTooltip="Good Response">
      <i
        class="bi"
        [ngClass]="
          userFeedback === 'thumbs_up'
            ? 'bi-hand-thumbs-up-fill'
            : 'bi-hand-thumbs-up'
        "></i>
    </button>

    <button
      class="btn-reset px-2"
      (click)="onThumbClick('thumbs_down')"
      ngbTooltip="Bad Response">
      <i
        class="bi"
        [ngClass]="
          userFeedback === 'thumbs_down'
            ? 'bi-hand-thumbs-down-fill'
            : 'bi-hand-thumbs-down'
        "></i>
    </button>
  </ng-container>
</div>
